import React, { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';

const GSAPExpandGallery = () => {
  const images = [
    '/images/realLarge.jpg',
    '/images/vase1.jpg',
    '/images/largeBasket.jpg',
    '/images/grande1.jpg',
    '/images/cor1.jpg',
    '/images/bb2.jpg',
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const imageRefs = useRef([]);

  // Detect screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get visible images count based on screen size
  const visibleImages = isMobile ? 3 : 6;

  useEffect(() => {
    // Animate all images
    imageRefs.current.forEach((img, index) => {
      if (index === activeIndex) {
        // Expand active image
        gsap.to(img, {
          flex: 2,
          scale: 1,
          opacity: 1,
          duration: 0.8,
          ease: 'power2.out'
        });
      } else {
        // Shrink inactive images
        gsap.to(img, {
          flex: 1,
          scale: 0.95,
          opacity: 0.7,
          duration: 0.8,
          ease: 'power2.out'
        });
      }
    });

    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => 
        prevIndex === visibleImages - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [activeIndex, visibleImages]);

  return (
    <div className="relative w-full h-[400px] md:h-[560px] lg:h-[580px] bg-gradient-to-b from-white to-pink-50 flex items-center justify-center overflow-hidden">
      {/* Full width container for images */}
      <div className="flex gap-1 md:gap-2 w-full h-full">
        {images.map((image, index) => (
          <div
            key={index}
            ref={(el) => (imageRefs.current[index] = el)}
            className={`relative overflow-hidden flex-1 ${
              index >= 3 ? 'hidden sm:flex' : ''
            }`}
            style={{ flex: 1 }}
          >
            <img
              src={image}
              alt={`Flower ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
      {/* Overlay text - centered on screen */}
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none z-10">
        

      </div>
    </div>
  );
};

export default GSAPExpandGallery;